export enum ObservationSource {
  APPLE_HEALTH = "APPLE_HEALTH",
  BIOREFERENCE_QA = "BIOREFERENCE_QA",
  BIOREFERENCE = "BIOREFERENCE",
  CARE_TEAM_UPLOAD = "CARE_TEAM_UPLOAD",
  CONNECTIVEHEALTH = "CONNECTIVEHEALTH",
  CONNECTIVEHEALTH_SIMULATION = "CONNECTIVEHEALTH_SIMULATION",
  DEMO = "DEMO",
  DERIVED = "DERIVED",
  EVERLYWELL = "EVERLYWELL",
  FALSEPILL_DIAGNOSTICS = "FALSEPILL_DIAGNOSTICS",
  FALSEPILL = "FALSEPILL",
  HEALTHIE_PRODUCTION = "HEALTHIE_PRODUCTION",
  HEALTHIE_STAGING = "HEALTHIE_STAGING",
  INTERNAL_QUESTIONNAIRE = "INTERNAL_QUESTIONNAIRE",
  LABCORP = "LABCORP",
  MESSENGER = "MESSENGER",
  OTHER_TRUSTED_LAB = "OTHER_TRUSTED_LAB",
  PATIENT_DEVICE = "PATIENT_DEVICE",
  PATIENT_UPLOAD = "PATIENT_UPLOAD",
  PMP_DEV = "PMP_DEV",
  PMP_PROD = "PMP_PROD",
  PMP_QA = "PMP_QA",
  QUEST_DIAGNOSTICS = "QUEST_DIAGNOSTICS",
  SMARTMETERRPM = "SMARTMETERRPM",
  SOLERA = "SOLERA",
  TASSO = "TASSO",
  TRUEPILL_DIAGNOSTICS = "TRUEPILL_DIAGNOSTICS",
  TRUEPILL = "TRUEPILL",
  WITHINGS = "WITHINGS"
}
